if (!customElements.get('hn-reference-menu')) {
  customElements.define(
    'hn-reference-menu',
    class extends HTMLElement {
      connectedCallback() {
        this.items = [...this.querySelectorAll('.hn-reference-header__item--has-children')];
        this.suppressFocusOpen = false;
        this.onDocumentPointerDown = (event) => {
          if (!this.contains(event.target)) this.closeAll();
        };
        this.items.forEach((item) => {
          const button = item.querySelector('[data-hn-disclosure]');
          item.addEventListener('pointerenter', () => {
            button.dataset.hnPointerWasOpen = button.getAttribute('aria-expanded');
            this.open(item);
          });
          item.addEventListener('pointerleave', () => this.close(item));
          item.addEventListener('focusin', () => {
            if (!this.suppressFocusOpen) this.open(item);
          });
          item.addEventListener('focusout', (event) => {
            if (!event.relatedTarget || !item.contains(event.relatedTarget)) this.close(item);
          });
          button?.addEventListener('pointerdown', () => {
            if (button.dataset.hnPointerWasOpen == null) {
              button.dataset.hnPointerWasOpen = button.getAttribute('aria-expanded');
            }
          });
          button?.addEventListener('click', (event) => {
            event.stopPropagation();
            const pointerWasOpen = button.dataset.hnPointerWasOpen;
            delete button.dataset.hnPointerWasOpen;
            if (event.detail > 0 && pointerWasOpen === 'true') {
              this.close(item);
            } else {
              this.open(item);
            }
          });
        });
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          const item = event.target.closest('.hn-reference-header__item--has-children');
          if (!item) return;
          event.preventDefault();
          event.stopPropagation();
          this.close(item);
          const button = item.querySelector('[data-hn-disclosure]');
          const panel = item.querySelector('[data-hn-submenu]');
          if (button && document.activeElement !== button) {
            this.suppressFocusOpen = true;
            button.focus();
            queueMicrotask(() => {
              this.suppressFocusOpen = false;
            });
          }
        });
        document.addEventListener('pointerdown', this.onDocumentPointerDown);
      }

      disconnectedCallback() {
        document.removeEventListener('pointerdown', this.onDocumentPointerDown);
      }

      open(item) {
        this.items.forEach((candidate) => {
          if (candidate !== item) this.close(candidate);
        });
        const button = item.querySelector('[data-hn-disclosure]');
        const panel = item.querySelector('[data-hn-submenu]');
        button?.setAttribute('aria-expanded', 'true');
        if (panel) {
          panel.inert = false;
          panel.setAttribute('aria-hidden', 'false');
        }
      }

      close(item) {
        const button = item.querySelector('[data-hn-disclosure]');
        const panel = item.querySelector('[data-hn-submenu]');
        button?.setAttribute('aria-expanded', 'false');
        if (panel) {
          panel.inert = true;
          panel.setAttribute('aria-hidden', 'true');
        }
      }

      closeAll() {
        this.items.forEach((item) => this.close(item));
      }
    }
  );
}
